import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'

interface AppMenuPops {
  adminRole: boolean
}

const AppMenu = (props:AppMenuPops) => {

  const auth = useSelector((state:any) => state.userInfo.data);
  // console.log('App 해더 userInfo',auth)
  let route_page = auth.user.roles.some((obj:any) => obj.role === 'ADMIN');

  const adminRole = props.adminRole

  return (
    <React.Fragment>
    {/* {route_page ?  */}
    {adminRole ? 
    <Box sx={{ display: "flex", backgroundColor: "#3e36a5", color: "#ffffff", fontWeight : 700, height:"68px", justifyContent: "center", cursor: "pointer"}}>
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>인사관리</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>성과관리</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>대가관리</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>사이트관리</Box>
    </Box>
    :
    <Box sx={{ display: "flex", backgroundColor: "#3e36a5", color: "#ffffff", fontWeight : 700, height:"68px", justifyContent: "center", cursor: "pointer"}}>
      {/* <Box sx={{display: "flex", marginLeft:2, cursor: "pointer"}} onClick={()=> nav('/insight/main')}> */}
      {/* <Box sx={{display: "flex", marginLeft:2, cursor: "pointer", fontWeight:700}}> */}
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>My</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>성과확인</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>작업물 제출</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>저작도구</Box>  
      <Box sx={{marginLeft:10, marginRight:10, fontSize: "20px", alignSelf: "center" , color: "#fff"}}>관리자</Box>  
      {/* </Box> */}
    </Box>
    }
    </React.Fragment>
  )
}

export default AppMenu